import { WorkflowOrder } from '../../../Api/Orders/ordersApi';
import { sameAccount } from '../../../utils/accountIds';

// The Opportunity the order began as keys its thread, so the thread outlasts the hand-off; a row without one has none.
export const orderThreadId = (order: WorkflowOrder): string | undefined =>
  order.originating_opportunity_sf_id || undefined;

// Files are only read here, so a row that does not say where it began can still list its own.
export const orderFilesParentId = (order: WorkflowOrder): string => order.originating_opportunity_sf_id || order.sf_id;

// A link naming the Opportunity still resolves after hand-off, to the same project row each time when it has several.
export const findOrder = (orders: WorkflowOrder[], id?: string): WorkflowOrder | undefined => {
  // Without an id, every row that names no originating Opportunity would match the fallback.
  if (!id) return undefined;
  return (
    orders.find((o) => o.id === id) ??
    orders.filter((o) => o.originating_opportunity_sf_id === id).sort((a, b) => (a.id < b.id ? -1 : 1))[0]
  );
};

// The list still holds the previous scope's rows until the next read answers, so the scope decides what may show.
export const inAccountScope = (order: WorkflowOrder, accountScope: string[]): boolean =>
  !order.account_id ||
  accountScope.includes('All') ||
  accountScope.some((accountId) => sameAccount(accountId, order.account_id));
